import axios from 'axios';

let cachedCountry = sessionStorage.getItem('user_country');

export const getUserCountry = async () => {
  if (cachedCountry) return cachedCountry;
  
  try {
    const res = await axios.get('https://get.geojs.io/v1/ip/country.json');
    cachedCountry = res.data.country;
    sessionStorage.setItem('user_country', cachedCountry);
    return cachedCountry;
  } catch (error) {
    console.error("Error fetching geolocation", error);
    return 'US'; // Default to US if geolocation fails
  }
};

export const getFormattedPrice = (course, country) => {
  if (country === 'NG') {
    const amount = Number(course.price_ngn || course.price_usd || 0);
    return `₦${amount.toLocaleString()}`;
  } else {
    const amount = Number(course.price_usd || course.price_ngn || 0);
    return `$${amount.toLocaleString()}`;
  }
};
